import Vue from 'vue'
import Vuex from 'vuex'
import * as Api from './config/http.js';
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLogin: false,
    config: {}, // 店铺配置信息
    addressList: [],
    userInfo: {},//用户信息
    cartInfo: [],
    cartNums: 0, //购物车数量
    shopMenu:{}
  },
  mutations: {
    getShopConfig(state, payload) {
      state.config = payload
    },
    getUserInfo(state, info) {
      state.userInfo = Object.assign({}, info)
    },
    getCartNums(state, payload) {
      state.cartNums = payload
    },
    getUserShipList(state, payload) {
      state.addressList = payload;
    },
    getShopMenu(state,payload){
      state.shopMenu=payload
    }
  },
  getters: {

  },
  actions: {
    getShopConfig(context, payload) {
      context.commit('getShopConfig', payload)
    },
    getUserInfo(context, payload) {
      context.commit('getUserInfo', payload)
    },
    getCartNumsAction(context, payload) {
      context.commit('getCartNums', payload)
    },
    getUserShipListAction(context) {
      Api.userShip().then(res => {
        if (res.status) {
          context.commit('getUserShipList', res.data)
        }
      });
    },
    getShopMenuAction(context){
      Api.shopMenu().then(res=>{
        if(res.status){
          context.commit('getShopMenu',res.data)
        }
      })
    }
  }
})
